var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('big-title',[_vm._v(" Beneficiarios"),_c('span',[_vm._v(".")])])],1),_c('investor-beneficiaries')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }